import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'website-footer',
  templateUrl: './website-footer.component.html',
  styleUrls: ['./website-footer.component.scss']
})
export class WebsiteFooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
